import React, { useCallback, useEffect, useState } from 'react'
import {
  Avatar,
  Container,
  Divider,
  GridList,
  GridListTile,
  GridListTileBar,
  MenuItem,
  Select,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Media, ImageModal, useImageModal } from 'src/components/media'
import { useFetchCSV, useGridSize } from 'src/hooks'
import { Charactor } from 'src/models/Charactor'

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  headerAnchor: {
    textAlign: 'right'
  },
  selectMenuIcon: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1)
  }
}))

const MotionCharactor: React.VFC = () => {
  const classes = useStyle()
  const [motions, error] = useFetchCSV<Motions>('0')
  const gridProps = useGridSize()
  const imageModalControl = useImageModal()
  const [charactor, setCharactor] = useState<Charactor>()
  const [charactors, setCharactors] = useState<Charactor[]>([])
  const [select, setSelect] = useState<string>('')

  const findCharactor = useCallback(
    () => charactors.find((e) => e.id === select),
    [charactors, select]
  )

  useEffect(() => {
    if (!motions?.header) return
    if (!motions?.body) return

    const ch = motions.body
      .map((e) => {
        const keys = motions.header
        return keys
          .map((key) => ({key, value: e[key].trim() }))
          .filter((e) => !!e.value && e.value !== '－')
      })
      .map((e) => {
        const [ent, ...rest] = e
        const name = ent.value
        const urls = rest.map((e) => ({
          title: e.key.replace('gsx$', ''),
          url: e.value
        }))
        return new Charactor(name, urls)
      })
    setCharactors(ch)
    if (ch.length > 0) {
      const chara = ch[Math.floor(Math.random() * ch.length)]
      setSelect(chara.id)
    }
  }, [motions?.body, motions?.header])

  useEffect(() => {
    const chara = findCharactor()
    if (!chara) return

    setCharactor(new Charactor('', []))
    const timer = setTimeout(() => setCharactor(chara), 0)
    return () => clearTimeout(timer)
  }, [select, findCharactor])

  return (
    <Container className={classes.root}>
      <ImageModal {...imageModalControl.props}>
        <Media url={imageModalControl.others.image} objectFit="contain" />
      </ImageModal>
      <header>
        <Typography variant="h4">各種モーション</Typography>
        <Typography variant="body2">キャラクター毎</Typography>
        <Typography variant="body2" className={classes.headerAnchor}>
          <a
            href="https://docs.google.com/spreadsheets/d/1yQN-8pYee_ycd1p4IUEd0YVR4s2Yg_CIWGf4x4YwgPc/edit#gid=272047564"
            target="_blank"
            rel="noopner noreferrer"
          >
            【ブルアカ】5chGIFまとめ保管庫【誰でも編集可】
          </a>
        </Typography>
      </header>
      <Divider className={classes.divider} />

      <div style={{ margin: 20 }}>
        <Select
          value={select}
          onChange={(e) => setSelect(e.target.value as string)}
        >
          {charactors.map((e) => (
            <MenuItem key={e.id} value={e.id}>
              <Avatar src={e.imageIcon} className={classes.selectMenuIcon} />
              {e.name}
            </MenuItem>
          ))}
        </Select>
      </div>

      <div>
        {error ?? <div>なんかエラーだった。</div>}
        {charactor ? (
          <div>
            <Typography>{charactor.name}</Typography>
            <GridList {...gridProps}>
              {charactor.objectUrls.map((e, i) => (
                <GridListTile key={i}>
                  <div
                    onClick={() => imageModalControl.others.handleOpen(e.url)}
                    style={{
                      backgroundColor: '#000',
                      width: '100%',
                      height: '100%'
                    }}
                  >
                    <Media url={e.url} objectFit="cover" />
                  </div>
                  <GridListTileBar
                    title={e.title}
                    subtitle={
                      <a
                        href={e.url}
                        target="_blank"
                        rel="noopner noreferrer"
                        style={{ color: 'white' }}
                      >
                        {e.url}
                      </a>
                    }
                  />
                </GridListTile>
              ))}
            </GridList>
          </div>
        ) : (
          <div>none</div>
        )}
      </div>
    </Container>
  )
}

export default MotionCharactor
